/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { SvenskdamLabradorTrendingMenu as ResolvedLabradorTrendingMenu } from 'sites/svenskdam/components/labrador/TrendingMenu';

export const LabradorTrendingMenu: typeof ResolvedLabradorTrendingMenu = withLabradorInstanceof((props) => {
    return <ResolvedLabradorTrendingMenu {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorTrendingMenuProps = PropsFromComponent<typeof LabradorTrendingMenu>;
